/**
 * Keep an overflow-auto modal from jumping when the user highlights
 * textarea/input text (browser scroll-into-view vs parent scroller).
 */
export function guardModalScroll(event) {
  const scroller = event.currentTarget.closest('[data-modal-scroll]')
  if (!scroller) return
  const top = scroller.scrollTop
  const restore = () => {
    if (scroller.scrollTop !== top) scroller.scrollTop = top
  }
  scroller.addEventListener('scroll', restore)
  requestAnimationFrame(restore)
  const stop = () => {
    restore()
    scroller.removeEventListener('scroll', restore)
    window.removeEventListener('mouseup', stop)
    window.removeEventListener('touchend', stop)
  }
  window.addEventListener('mouseup', stop)
  window.addEventListener('touchend', stop)
}
